import React, { useState } from 'react';
import { Card, Button, Drawer, Tabs } from 'antd';
import { PlusCircleOutlined } from '@ant-design/icons';
import MemberSelector from '../components/MemberSelector';
import StageEvaluationComponent from '../components/StageEvaluationComponent';
import SportsTestComponent from '../components/SportsTestComponent';

const StageEvaluation = () => {
  // 会员选择相关状态
  const [selectedMember, setSelectedMember] = useState(null);
  const [memberDrawerVisible, setMemberDrawerVisible] = useState(false);

  // 选择会员回调
  const handleMemberSelect = (member) => {
    setSelectedMember(member);
    setMemberDrawerVisible(false);
  };

  // 获取当前会员ID
  const getSelectedMemberId = () => {
    return selectedMember ? [selectedMember.id] : [];
  };

  return (
    <div className="menu-item-content">
      <Card 
        title="综合测评" 
        style={{ margin: '16px' }}
        extra={
          <Button 
            type="primary" 
            onClick={() => setMemberDrawerVisible(true)}
            icon={<PlusCircleOutlined />}
          >
            选择会员
          </Button>
        }
      >
        {selectedMember ? (
          <Tabs defaultActiveKey="1">
            <Tabs.TabPane tab="阶段测评" key="1">
              <StageEvaluationComponent 
                memberId={selectedMember.id}
                memberInfo={selectedMember}
                onMemberChange={(newInfo) => {
                  setSelectedMember(prev => ({...prev, ...newInfo}));
                }}
              />
            </Tabs.TabPane>
            <Tabs.TabPane tab="体育测试" key="2">
              <SportsTestComponent 
                memberId={selectedMember.id}
                memberInfo={selectedMember}
                onMemberChange={(newInfo) => {
                  setSelectedMember(prev => ({...prev, ...newInfo}));
                }}
              />
            </Tabs.TabPane>
          </Tabs>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px' }}>
            <div>请先选择会员</div>
          </div>
        )}
      </Card>

      {/* 会员选择抽屉 */}
      <Drawer
        title="选择会员"
        placement="right"
        width={480}
        onClose={() => setMemberDrawerVisible(false)}
        open={memberDrawerVisible}
      >
        <MemberSelector
          onSelect={handleMemberSelect}
          selectedMemberIds={getSelectedMemberId()}
        />
      </Drawer>
    </div>
  );
};

export default StageEvaluation;